import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "AccountsCallout" */ './lazyIndex'),
    { name: 'AccountsCallout' }
);

export const PendingAccountsCallout: LazyComponent<unknown, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.PendingAccountsCallout
);

export const PendingAccountsWelcomeCallout: LazyComponent<unknown, unknown, void> =
    createLazyComponent(lazyModule, m => m.PendingAccountsWelcomeCallout);

export const SuggestedAccountsView: LazyComponent<unknown, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.SuggestedAccountsView
);
